import { Issue } from '../types';
import { fetchIssuesFromBlob, isAzureStorageConfigured } from './azureStorage';

// NOTE: Backend API deprecated - application now uses Azure Blob Storage exclusively
// The API_BASE_URL and backend fallback code below are retained for reference only
// and are not used in production (Azure Static Web Apps deployment)
// const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';

/**
 * Fetches all issues from Azure Blob Storage
 * @returns Promise resolving to an array of Issue objects
 * @throws Error if the request fails
 * 
 * NOTE: Previously supported backend API fallback, but this has been removed.
 * Application now requires Azure Blob Storage configuration (VITE_AZURE_STORAGE_ACCOUNT_NAME,
 * VITE_AZURE_BLOB_CONTAINER_NAME, VITE_AZURE_BLOB_NAME environment variables).
 */
export const fetchIssues = async (): Promise<Issue[]> => {
  // Fetch directly from Azure Blob Storage
  if (isAzureStorageConfigured()) {
    console.log('Fetching issues from Azure Blob Storage...');
    return await fetchIssuesFromBlob();
  }

  // No fallback available - Azure Storage is required
  throw new Error('Azure Blob Storage is not configured. Please set VITE_AZURE_STORAGE_ACCOUNT_NAME, VITE_AZURE_BLOB_CONTAINER_NAME, and VITE_AZURE_BLOB_NAME environment variables.');

  /* DEPRECATED: Backend API fallback code (removed for Azure Static Web Apps deployment)
  console.log('Fetching issues from backend API (Azure not configured)...');
  const baseUrl = apiUrl || API_BASE_URL;
  try {
    const response = await fetch(`${baseUrl}/api/issues`);
    if (!response.ok) {
      throw new Error(`Failed to fetch issues: ${response.statusText}`);
    }
    const data: Issue[] = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching issues:', error);
    throw error;
  }
  */
};

